define('presentation/shell/viewModels/loginShellViewModel',[
    'businessServices/browserSupport/browserType',
    'businessServices/events/eventManager',
    'businessServices/router/router',
    'common/promises/promiseFactory',
    'constants/shellNameEnumerations',
    'presentation/common/window/windowControl',
    'settings/navigationConfiguration'
], function () {
    return function () {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        let _promiseFactory = new PromiseFactoryConstructor();

        const _browserType = require('businessServices/browserSupport/browserType');
        const _navigationConfiguration = require('settings/navigationConfiguration');
        const _shellNameEnumerations = require('constants/shellNameEnumerations');
        const _windowControl = require('presentation/common/window/windowControl');

        let _eventManager = null;

        const loginPath = _navigationConfiguration.loginPageUrl;
        const reactivationPlansPath = _navigationConfiguration.routesById.reactivationPlans.url;
        const reactivationSuccessPath = _navigationConfiguration.routesById.reactivationSuccess.url;

        self.router = null;
        self.childViewModel = ko.observable(null);
        self.shellIsActive = ko.observable(true);
        self.isScrollActive = ko.observable(false);

        self.isMobileDevice = ko.pureComputed(() => _browserType.isMobileDevice);

        self.isLoginScreen = ko.pureComputed(() => self.router.activeInstruction().fragment === loginPath);

        self.isWideContentContainer = ko.pureComputed(() => {
            if (self.router.activeInstruction()){
                return self.router.activeInstruction().fragment === reactivationPlansPath ||
                    self.router.activeInstruction().fragment === reactivationSuccessPath;
            }
            return false;
        });

        const _onShellUpdated = (shellName) => {
            if (shellName === _shellNameEnumerations.login) {
                self.childViewModel(self.router.activeItem());
                self.shellIsActive(true);
            } else {
                self.childViewModel(null);
                self.shellIsActive(false);
            }
        };

        self.navigateToHomePage = () => {
            _windowControl.openHomePage("_self");
        };

        self.activate = () => {
            self.router = require('businessServices/router/router');
            _eventManager = require('businessServices/events/eventManager');

            return _initialize();
        };

        const _initialize = () => {
            self.childViewModel(self.router.activeItem());
            if (self.childViewModel() !== null) {
                self.childViewModel().parent = self;
            }

            _eventManager.subscribeShellUpdated(_onShellUpdated);

            return _promiseFactory.wait();
        };
    };
});
